Object.defineProperty(exports,"__esModule",{value:true});var NativeModules={};exports.default=NativeModules;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/modules/NativeModules/index.js
 ** module id = 857
 ** module chunks = 0
 **/